<template>
  <div style="height: 100%; overflow: visible">
        <button class="btn btn-default" v-on:click="error_no--" style="float:left;">Previous</button>
        <button class="btn btn-default" v-on:click="error_no++" style="float:right;">Next</button>
        <p align="center">{{ error_no }}/{{ errors.length }}</p>
        <form v-if="error_no>=0" style="clear: both; width: 100%;">
            {{ errors[error_no].type }}:<br>
            <span style="padding-left: 13px;" v-html="errors[error_no].content_display"></span><br>
            <input type="text" class="form-control" v-model="errors[error_no].replacement" v-on:input="unsaved_changes = true" style="width: 100%;">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="errors[error_no].error">
                <label class="form-check-label" for="exampleCheck1">Error</label>
            </div>
            <button class="btn btn-default" v-bind:disabled="!unsaved_changes" v-on:click="onSave">Save</button>
        </form>
  </div>
</template>

<script>
  import axios from 'axios'
  
  export default {
    data () {
      return {
        errors: [],
        error_no: -1,
        unsaved_changes: false
      }
    },

    methods: {
        onSave: function (event) {
            const replacements = this.errors.reduce((replacements, error) => {
                if(error.content != error.replacement)
                    replacements.push({bdtns_no: error.bdtns_no, line_no: error.line_no, content: error.content, replacement: error.replacement, error: error.error});
                return replacements;
            }, []);
            console.log(replacements);
            axios.post("http://localhost:8081/bdtnsreplacements", replacements)
                .then(response => {
                    if(response.data) 
                        console.log(response.data);
                    else
                        this.unsaved_changes = false;
                    })
                .catch(e => {console.log(e)})
        }
    },

    watch: {
        error_no: function (val) {
            this.$emit('error-changed', {bdtns_no: this.errors[val].bdtns_no, line_no: this.errors[val].line_no});
        }
    },

    mounted () {
        axios.get("http://localhost:8081/bdtnserrors")
            .then(response => {
                this.errors = response.data;
                this.errors = this.errors.filter(error => error.type != "Multiline" && error.type != "Inverted Superscript");
                this.error_no = 0;
            })
            .catch(e => {console.log(e)})
    }
  }
</script>

<style>
span.error_segment {
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/BDTNSBugView.vue